module.exports = __webpack_public_path__ + "static/hero5-59f7000e6b78547db37b1fb795656826.jpg";